import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const token = this.authService.getToken();
    if (!token) {
      this.authService.logout()
      this.router.navigate(['/login']);
      return false;
    }

    const data = JSON.parse(atob(token.split('.')[1]));
    
    const exp = data.exp;
    
    const currentTime = Math.floor(new Date().getTime() / 1000);
    
    if(exp < currentTime){
      this.authService.logout()
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
